import React, { FC, useState } from "react";
import { Button } from "primereact/button";
import { AdmissionChecklistSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Props {
  data: AdmissionChecklistSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section13: FC<Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div style={{ width: "100%", background: "linear-gradient(180deg, #f8fbff 0%, #f8fafc 100%)", padding: "3rem 1.25rem" }}>
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#185da2", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>Optional Page</div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>Admission Checklist</div>
            <div style={{ color: "#64748b", marginTop: "0.65rem", lineHeight: 1.7, maxWidth: "760px" }}>
              Give families a move-in preparation checklist they can review before admission day, with documents, medications, personal items, routines, and emotional preparation.
            </div>
          </div>
          <Button label="Edit Admission Checklist" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>
        <div className="grid">
          {(data?.checklistCategories || []).map((category, index) => (
            <div className="col-12 md:col-6 lg:col-4" key={`${category.title}-${index}`}>
              <div style={{ background: "#ffffff", border: "1px solid #dbe7f3", borderRadius: "24px", padding: "1.2rem", height: "100%", boxShadow: "0 16px 32px rgba(15,61,99,0.06)" }}>
                <div style={{ color: "#185da2", fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>{category.title}</div>
                <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.85, color: "#475569" }}>
                  {(category.items || []).slice(0, 6).map((item, itemIndex) => <li key={`${item}-${itemIndex}`}>{item}</li>)}
                </ul>
                {(category.items || []).length > 6 ? (
                  <div style={{ color: "#64748b", marginTop: "0.75rem", fontWeight: 600 }}>+ {(category.items || []).length - 6} more</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section13;
